enum AppSections {
  _3DINSTANCES = "e3dinstances",
  ALTERATION_FORMS = "alteration-forms",
  ANNEXDATA = "annexdata",
  ANNOTATIONS = "annotations",
  CHELEMENTS = "chelements",
  CLIENTS = "clients",
  COLLECTIONS = "collections",
  COMMUNITY_RULES = "community-rules",
  CONDITION_REPORTS = "condition-reports",
  CONDITION_REPORTS_DOCUMENTS = "condition-reports-documents",
  DASHBOARD = "dashboard",
  E3DS = "e3ds",
  EMAIL_CONFIRMATION = "email-confirmation",
  HOME = "/",
  LICENSE_AGREEMENT = "license-agreement",
  MATERIALS = "materials",
  MY_PROFILE = "my-profile",
  MY_LISTS = "my_lists",
  PILOTS = "pilots",
  SEARCH = "search",
  SIGN_IN = "sign-in",
  SIGNUP = "signup",
  SITES = "sites",
  SPATIAL_RELATIONS = "spatialrelations",
  STATIC_PAGES = "static-pages",
  TERMS_AND_CONDITIONS = "terms-and-conditions",
  TEXTURES = "textures",
  USERS = "users",
}

export default AppSections;
